import axios from 'axios';

class Manager {
  constructor() {
    this.baseUrl = process.env.APP_URL + '/users/account';
    this.subscriptionsUrl = process.env.APP_URL + '/subscriptions';
    this.clinicalCenterUrl = process.env.APP_URL + '/users/centers';
  }

  getAccountInfo() {
    return axios.get(this.baseUrl);
  }

  setAccountInfo(user) {
    return axios.post(this.baseUrl, user);
  }

  async changePassword(currentPassword, newPassword, newPasswordConfirmation) {
      return await axios.post(this.baseUrl + '/change-password', {
        currentPassword: currentPassword,
        newPassword: newPassword,
        newPasswordConfirmation: newPasswordConfirmation
      });

  }

  getSubscriptions(perPage, page){
    return axios.get(this.subscriptionsUrl, {
      params: {
        perPage: perPage,
        page: page
      }

    });
  }

  getClinicalCenter(perPage, page){
    return axios.get(this.clinicalCenterUrl, {
      params: {
        perPage: perPage,
        page: page
      }

    });
  }

  setClinicalCenter(clinic, id){
    return axios.put(this.clinicalCenterUrl + '/' + id, clinic);
  }

  getSubscription(id){
    return axios.get(this.subscriptionsUrl + '/' +id);
  }

  setSubscription(data){
    return axios.post(this.subscriptionsUrl, data);
  }

  getTaskTypes(){
    return axios.get(this.baseUrl + '/check-list-settings');
  }

  getSkillDomain(perPage, page){
    return axios.get(this.baseUrl + '/skill-fields', {
      params: {perPage, page},
    });
  }

  setSkillDomain(name,id){
    return axios.put(this.baseUrl + '/skill-fields/' + id, {
      name
    });
  }

  addSkillDomain(name){
    return axios.post(this.baseUrl + '/skill-fields/', {
      name
    });
  }

  deleteSkillDomain(id){
    return axios.delete(this.baseUrl + '/skill-fields/' + id);
  }

  setTaskTypes(data){
    return axios.post(this.baseUrl + '/check-list-settings', data);
  }

  getSubscriptionComments(id, perPage, page){
    return axios.get(this.subscriptionsUrl + '/' + id + '/comment', {
      params: {perPage, page},
    });
  }

  comment(id, data) {
    return axios.post(this.subscriptionsUrl + '/' + id + '/comment', data);
  }

  markCommentAsViewed(id) {
    return axios.post(this.subscriptionsUrl + '/' + id + '/comment/view');
  }
}

export default new Manager();



// WEBPACK FOOTER //
// ./src/modules/profile/api/Manager.js